import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { TheoryAccessSellingPageComponent } from './TheoryAccessSellingPageComponent';
import stores from '../../../../stores';

class TheoryAccessSellingPageContainerClassComponent extends Component {
  componentDidMount() {
    const { schoolId } = this.props;
    stores.theoryAccessStore.checkRemainingAccess(schoolId);
  }

  render() {
    const { isAccessesChecking, hasRemainingAccesses } = stores.theoryAccessStore;
    const {
      schoolPhone, schoolName, cost, schoolId,
    } = this.props;

    return (
      <TheoryAccessSellingPageComponent
        isAccessesChecking={isAccessesChecking}
        hasRemainingAccesses={hasRemainingAccesses}
        schoolPhone={schoolPhone}
        schoolName={schoolName}
        schoolId={schoolId}
        cost={cost}
      />
    );
  }
}

TheoryAccessSellingPageContainerClassComponent.propTypes = {
  schoolPhone: PropTypes.string.isRequired,
  schoolName: PropTypes.string.isRequired,
  cost: PropTypes.string.isRequired,
  schoolId: PropTypes.string.isRequired,
};

const TheoryAccessSellingPageContainer = observer(TheoryAccessSellingPageContainerClassComponent);

export { TheoryAccessSellingPageContainer };
